import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';

export const Label = styled(Box).attrs({
  color: 'secondaryText',
  pb: 2,
})`
  opacity: ${p => (p.isDisabled ? 0.4 : 1)};
`;

export const InputLabel = styled(Text).attrs({
  marginBottom: '8px',
  color: 'primaryText',
  size: 'small',
})``;

export const ResultWrapper = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  position: 'relative',
  width: '100%',
  cursor: 'pointer',
  padding: '10px',
  height: '40px',
})`
  user-select: none;
  max-width: ${({ maxWidth }) => maxWidth}px;
  ${({ isHovered, theme }) =>
    isHovered && `background-color: ${theme.colors.highlights}`};

  &:hover {
    background-color: ${({ theme }) => theme.colors.highlights};
  }
`;

export const Result = styled(Text).attrs({
  size: 'normal',
  inline: true,
  color: 'secondaryText',
})`
  padding-left: 10px;
`;

export const ResultsContainer = styled(Box).attrs(({ isVisible }) => ({
  display: isVisible ? 'block' : 'none',
  position: 'absolute',
  p: 0,
  bg: 'background',
  width: '100%',
  color: 'secondaryText',
  border: '1px solid',
  borderColor: 'heavyLineOutline',
  borderRadius: '4px',
  maxWidth: '100%',
}))`
  overflow: auto;
  list-style: none;
  top: 67px;
  z-index: 20;
`;

export const TooltipChild = styled(Box).attrs(() => ({
  position: 'absolute',
  color: 'primaryText',
  bg: 'background',
  borderRadius: '5px',
  p: '10px',
  align: 'start',
}))`
  display: none;
  white-space: nowrap;
  top: 100%;
  width: max-content;
`;

export const IconWrapper = styled(Box).attrs(() => ({
  color: 'secondaryText',
}))`
  cursor: pointer;
`;

export const ButtonContainer = styled(Box).attrs(() => ({
  flow: 12,
  width: '100%',
}))``;

export const CallTakerModeButton = styled(Button).attrs(() => ({}))`
  position: relative;
  &:hover ${TooltipChild} {
    display: flex;
  }
`;

export const ErrorText = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  py: 1,
})``;

export const NoResultText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  fontWeight: 'bold',
  px: 2,
})``;

export const ModalTitle = styled(Text).attrs({
  color: 'primaryText',
  marginBottom: '13px',
  size: 'xlarge',
})``;

export const ModalDescription = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})``;

// The -9px horiztonal margin is needed because the 'Checkbox' component has extra margin and
// padding by default. Based on the design, the checkbox needed to align with other fields in the
// modal, hence the negative margin.
export const RememberPositionBox = styled(Box).attrs({
  margin: '3px -9px 24px',
})``;

export const SwitchContainer = styled(Box).attrs(({ theme }) => ({
  align: 'center',
  border: `1px solid ${theme.colors.heavyLineOutline}`,
  borderRadius: '5px',
  horizontal: true,
  justify: 'space-between',
  marginBottom: '12px',
  padding: '5px 16px',
}))``;

export const SwitchLabel = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})``;
